import React, { forwardRef } from 'react';
export const TooltipText = (StyledTooltipText) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledTooltipText ref={ref} {...props}>
        {children}
      </StyledTooltipText>);
});
